
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/News/NewsItem .vue';
import { getNewsList, getBaseInfo } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  bannerImg: string = '';
  baseInfo: any = {};
  classId: string = '1';
  async created() {
    this.onLoad();
  }
  async onLoad() {
    const data = {
      page: this.page,
      pageSize: 10,
      columnId: this.classId,
    };
    getNewsList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode !== 200) {
      this.finished = true;
    } else {
      if (!res.data.list || res.data.list.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.list || res.data.list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.list];
        }
      }
    }
    this.loading = false;
  }
}
